export default __webpack_public_path__ + "static/media/080_finish_bad.5470df60.mp4";